module.exports = __webpack_public_path__ + "Tinebase/js/ace-mode-assembly_x86-FAT.js";